// extracted by mini-css-extract-plugin
export default {"root":"resource-library_root__M6+v-","accordion":"resource-library_accordion__3MQi0"};